import { fabContentPadClass } from "@/components/shared/Fab";
import { cn } from "@/lib/utils";

/**
 * Content column width. Mobile stays readable; desktop is wide enough for tables/Gantt.
 * AppShell owns this — pages must NOT nest another max-w-*.
 */
export const APP_CONTENT_WIDTH_CLASS = "max-w-3xl lg:max-w-7xl" as const;

/** Standard vertical rhythm + FAB clearance under BottomNav. */
export function pageClassName(...extra: Array<string | false | null | undefined>): string {
  return cn("w-full space-y-4", fabContentPadClass, ...extra);
}

/** Subtitle under Header. */
export const pageLeadClass = "-mt-2 text-sm text-slate-600 dark:text-slate-400";
